<template>
    <div class="Field__Component">
        <div><slot>
            <router-link v-if="field.isAdmin" :to="adminLink">{{value}}</router-link>
            <router-link v-else :to="isTransferContextLink">{{value}}</router-link>
        </slot></div>
    </div>
</template>

<script>
export default {
    name: 'FieldLink',
    props: ['value', 'item', 'field', 'isTransferContext'],
    computed: {
        adminLink() {
            const path = `/admin/reports/${this.item.Id}`;
            // Only add fromProfileId when field is marked as transfer context
            if (this.isTransferContext && this.item.TransferredFrom?.Id) {
                return `${path}?fromProfileId=${this.item.TransferredFrom.Id}`;
            }
            return path;
        },
        isTransferContextLink() {
            const path = `/reports/${this.item.Id}`;
            if (this.isTransferContext && this.item.TransferredFrom?.Id) {
                return `${path}?fromProfileId=${this.item.TransferredFrom.Id}`;
            }
            return path;
        }
    }
};
</script>

<style scoped>

</style>
